/**
 * QuestionList
 */
import React from 'react';
/** Main description for this component. */
var QuestionList = function (_a) {
    var className = _a.className, children = _a.children;
    return React.createElement("div", { className: className }, children);
};
export default QuestionList;
